import React from "react";
import defaults from "lodash/defaults";
import View from "./tasks-view";
import AddEditTaskModal from "./components/add-edit-task-modal";
import JWPlayerVideoModal from "../../../parts/modals/jwplayer-video";
import ActivityDrawer from "../../../parts/activity-drawer/ActivityDrawer";

const TasksController = async ({
  res,
  req,
  locals,
  load,
  momentTZ,
  session,
}) => {
  const organizationRoleName = locals.organizationRoleName;

  const isAllowToLoadAllAthletes =
    organizationRoleName &&
    (organizationRoleName === "Admin" || organizationRoleName === "Owner");
  const { query = {} } = req;

  defaults(query, {
    tab: "programming",
    completed: false,
    modal: {},
    filterGroup:
      isAllowToLoadAllAthletes &&
      query.modal &&
      query.modal.type &&
      (query.modal.type === "edit-task" || query.modal.type === "add-task")
        ? "organization"
        : "all",
  });
  const {
    tab,
    completed,
    modal,
    id,
    filterGroup,
    organizationCoach = undefined,
  } = query;

  const activeUser = locals.activeUser;
  const { organizationId = null } = activeUser;
  const loadPromises = [];
  if (organizationId) {
    loadPromises.push(load("usersOrganization"));
  }

  if (isAllowToLoadAllAthletes) {
    loadPromises.push(load("allAthletesFromOrganization"));
  }

  if (organizationCoach) {
    loadPromises.push(
      load("coachOrganizationInformation", { user: organizationCoach }),
      load("tasks", { tab, completed, filterGroup, organizationCoach })
    );
  } else {
    loadPromises.push(
      load("tasks", {
        tab,
        completed,
        filterGroup,
        organizationCoach: undefined,
      })
    );
  }

  await Promise.all(loadPromises);

  let taskToEdit = null;
  if (modal.type === "edit-task" && id) {
    taskToEdit = locals.tasks.thisWeek.find((task) => task._id === id);
    if (!taskToEdit) {
      taskToEdit = locals.tasks.upcoming.find((task) => task._id === id);
    }
  }

  locals.modal = {
    "add-task": (
      <AddEditTaskModal
        tab={tab}
        momentTZ={momentTZ}
        isAllowToLoadAllAthletes={isAllowToLoadAllAthletes}
      />
    ),
    "edit-task": (
      <AddEditTaskModal
        tab={tab}
        momentTZ={momentTZ}
        task={taskToEdit}
        isAllowToLoadAllAthletes={isAllowToLoadAllAthletes}
      />
    ),
    "exercise-set-video": (
      <JWPlayerVideoModal
        mediaId={query.mediaId}
        originalId={query.originalId}
        athleteId={query.uploaderId || query.athleteId}
      />
    ),
    "activity-feed": <ActivityDrawer />,
  }[modal.type];

  res.body = <View query={query} />;
};

export default TasksController;
